<template>
  <div
    class="paintingExhibition"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="database">Database</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ eng_typeName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInRight"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="temple hidden-xs-only">
      <div class="section">
        <div class="temple_box">
          <div class="temple_item" @click="changeTemple(index,item.id)" v-for="(item,index) in paintingList" :key="index"
          :class="isActiveTemple == index ? 'isActiveTemple' : ''">
            <div class="itemName">{{ item.englishName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="temple hidden-sm-and-up">
      <div class="section">
        <div class="temple_box">
          <div class="temple_item" @click="mobileChangeTemple(index,item.id)" v-for="(item,index) in paintingList" :key="index"
          :class="isActiveTemple == index ? 'isActiveTemple' : ''">
            <div class="itemName">{{ item.englishName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="waterfallBox hidden-xs-only">
        <water-fall-base
          :data="cardList"
          v-if="cardList.length !== 0"
        ></water-fall-base>
        <div class="noMessage" v-if="cardList.length == 0 && !loading">none</div>
      </div>
      <div class="waterfallBox hidden-sm-and-up">
        <water-fall-mobile-base
          :data="cardListMobile"
          v-if="cardListMobile.length !== 0"
        ></water-fall-mobile-base>
        <div class="noMessage" v-if="cardListMobile.length == 0 && !loading">none</div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="loading"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <div class="paintingExhibition" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="database"> གྲངས་མཛོད།</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ za_typeName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInRight"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="temple hidden-xs-only">
      <div class="section">
        <div class="temple_box">
          <div class="temple_item" @click="changeTemple(index,item.id)" v-for="(item,index) in paintingList" :key="index"
          :class="isActiveTemple == index ? 'isActiveTemple' : ''">
            <div class="itemName">{{ item.zangName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="temple hidden-sm-and-up">
      <div class="section">
        <div class="temple_box">
          <div class="temple_item" @click="mobileChangeTemple(index,item.id)" v-for="(item,index) in paintingList" :key="index"
          :class="isActiveTemple == index ? 'isActiveTemple' : ''">
            <div class="itemName">{{ item.zangName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="waterfallBox hidden-xs-only">
        <water-fall-base
          :data="cardList"
          v-if="cardList.length !== 0"
        ></water-fall-base>
        <div class="noMessage" v-if="cardList.length == 0 && !loading">
          གནས་སྐབས་གཞི་གྲངས་མེད་པ་
        </div>
      </div>
      <div class="waterfallBox hidden-sm-and-up">
        <water-fall-mobile-base
          :data="cardListMobile"
          v-if="cardListMobile.length !== 0"
        ></water-fall-mobile-base>
        <div class="noMessage" v-if="cardListMobile.length == 0 && !loading">
          གནས་སྐབས་གཞི་གྲངས་མེད་པ་
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <div class="paintingExhibition" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="database">数据库</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ typeName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInRight"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="temple hidden-xs-only">
      <div class="section">
        <div class="temple_box">
          <div class="temple_item" @click="changeTemple(index,item.id)" v-for="(item,index) in paintingList" :key="index"
          :class="isActiveTemple == index ? 'isActiveTemple' : ''">
            <div class="itemName">{{ item.chineseName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="temple hidden-sm-and-up">
      <div class="section">
        <div class="temple_box">
          <div class="temple_item" @click="mobileChangeTemple(index,item.id)" v-for="(item,index) in paintingList" :key="index"
          :class="isActiveTemple == index ? 'isActiveTemple' : ''">
            <div class="itemName">{{ item.chineseName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="waterfallBox hidden-xs-only">
        <water-fall-base
          :data="cardList"
          v-if="cardList.length !== 0"
        ></water-fall-base>
        <div class="noMessage" v-if="cardList.length == 0 && !loading">暂无数据</div>
      </div>
      <div class="waterfallBox hidden-sm-and-up">
        <water-fall-mobile-base
          :data="cardListMobile"
          v-if="cardListMobile.length !== 0"
        ></water-fall-mobile-base>
        <div class="noMessage" v-if="cardListMobile.length == 0 && !loading">暂无数据</div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { templePage,productPage } from "../../api/management";
import waterFallBase from "../../components/waterFallBase.vue";
import waterFallMobileBase from "../../components/waterFallMobileBase.vue";
import { throttle } from 'lodash'
export default {
  components: {
    waterFallBase,
    PicTop,
    waterFallMobileBase,
  },
  data() {
    return {
      total: null,
      language: this.$store.state.language,
      // 画院
      templeInfo:{
        current: 1,
        productCategory:this.$route.query.category,
        pageSize: 10000,
      },
      //画院列表
      paintingList: [
        {
          chineseName: "全部",
          zangName: "ཡོངས་རྫོགས།",
          id: "",
          englishName: "All",
        },
      ], 
      queryInfo: {
        current: 1,
        pageSize: 9,
        category: this.$route.query.category,
        databaseSeen: true,
        templeId: "",
      },
      mobileTotal: null,
      Info: {
        current: 1,
        pageSize: 6,
        category: this.$route.query.category,
        databaseSeen: true,
        templeId: "",
      },
      isActiveTemple:'',//选择的画院
      typeName: "",
      za_typeName: "",
      eng_typeName: "",
      cardList: [],
      cardListMobile: [],
      loading: false,
      isLoading:false
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  created() {
    this.getTemplePage()
    //   this.getProductPage()
  },
  methods: {
    //画院列表
    async getTemplePage() {
      const res = await templePage(this.templeInfo);
      if (res.code == 1) {
        this.paintingList = this.paintingList.concat(res.data.records);
        console.log(this.paintingList);
      }
    },
    async getProductPage() {
      this.loading = true
      let category = this.queryInfo.category;
      if (category == 1) {
        this.typeName = "唐卡";
        this.za_typeName = " ཐང་ག ";
        this.eng_typeName = "Thangka";
      } else if (category == 2) {
        this.typeName = "泥塑";
        this.eng_typeName = "Clay sculpture";
        this.za_typeName = " འཇིམ་བཟོ།";
      } else if (category == 3) {
        this.typeName = "壁画";
        this.eng_typeName = "Mural";
        this.za_typeName = "ལྡེབས་རིས། ";
      } else if (category == 4) {
        this.typeName = "堆绣";
        this.eng_typeName = "Pile embroidery";
        this.za_typeName = " དྲས་དྲུབ། ";
      } else if (category == 5) {
        this.typeName = "彩绘";
        this.eng_typeName = "Paintings";
        this.za_typeName = " ཚོན་རིས། ";
      } else if (category == 6) {
        this.typeName = "其他";
        this.eng_typeName = "Other";
        this.za_typeName = " གཞན་དག ";
      }
      const res = await productPage(this.queryInfo);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.cardList = this.cardList.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileProductPage();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getProductPage();
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    PCscrollBottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight+1 >= scrollHeight) {
        if(this.isLoading) {
          if (this.queryInfo.current * 9 >= this.total) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.queryInfo.current++;
          this.getProductPage();
        }
      } else {
        this.isLoading = true
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
        if(this.isLoading) {
          if (this.Info.current * 6 >= this.mobileTotal) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.Info.current++;
          this.getMobileProductPage();
        }
      } else {
        this.isLoading = true
      }
    },2000),
    async getMobileProductPage() {
      this.loading = true
      let category = this.queryInfo.category;
      if (category == 1) {
        this.typeName = "唐卡";
        this.za_typeName = "  ཐང་ག ";
        this.eng_typeName = "Thangka";
      } else if (category == 2) {
        this.typeName = "泥塑";
        this.eng_typeName = "Clay sculpture";
        this.za_typeName = "འཇིམ་བཟོ། ";
      } else if (category == 3) {
        this.typeName = "壁画";
        this.eng_typeName = "Mural";
        this.za_typeName = "ལྡེབས་རིས།";
      } else if (category == 4) {
        this.typeName = "堆绣";
        this.eng_typeName = "Pile embroidery";
        this.za_typeName = " དྲས་དྲུབ། ";
      } else if (category == 5) {
        this.typeName = "彩绘";
        this.eng_typeName = "Paintings";
        this.za_typeName = "ཚོན་རིས། ";
      } else if (category == 6) {
        this.typeName = "其他";
        this.eng_typeName = "Other";
        this.za_typeName = " གཞན་དག ";
      }
      const res = await productPage(this.Info);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.cardListMobile = this.cardListMobile.concat(res.data.records);
        this.mobileTotal = res.data.total;
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    // pc端切换
    changeTemple(index,id) {
      this.loading = true
      this.isActiveTemple = index
      this.queryInfo.templeId = id
      this.queryInfo.current = 1
      this.cardList = []
      setTimeout(() => {
        this.getProductPage();
      }, 300);
    },
    // 手机端切换
    mobileChangeTemple(index,id) {
      this.loading = true
      this.isActiveTemple = index
      this.Info.templeId = id
      this.Info.current = 1
      this.cardListMobile = []
      setTimeout(() => {
        this.getMobileProductPage();
      }, 300);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss">
.paintingExhibition {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .exhibitionTop {
    border-bottom: 1px solid #f4f5f6;
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .temple {
    margin:20px 0;
    .section {
      .temple_box {
        width: 100%;
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        .temple_item {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 196px;
          //用margin控制一行或多行展示时（文字不会产生偏移）
          margin-right: 4px;
          height: 90px;
          position: relative;
          font-family: "fangzang";
          .itemName {
            font-size: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 4; /* 限制行数为3 */
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .itemDuty {
            font-size: 18px;
          }
        }
        .eng_item {
          font-family: "Times New Roman", Times, serif;
        }
        .isActiveTemple {
          background-color: #304462;
          color: #fff;
        }
      }
    }
  }
  .section {
    .waterfallBox {
      .noMessage {
        margin: 20px 0;
        letter-spacing: 4px;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
      }
    }
    .loading {
      margin-bottom: 20px;
      .el-loading-mask {
        .el-loading-spinner {
          .el-icon-loading {
            color: #ef3731;
          }
          .el-loading-text {
            color: #ef3731;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .paintingExhibition {
    background-size: 15%;
    padding-bottom: 1rem;
    position: relative;
    .exhibitionTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
        span {
          cursor: pointer;
        }
      }
      .moblieCloudLeft {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .temple {
      .section {
        .temple_box {
          .temple_item {
            padding: 0.1rem 0;
            width: 30%;
            height: 1.5rem;
            margin-right: 4%;
            .itemName {
              height: 100%;
              width: 100%;
              font-size: 0.3rem;
              // 超过四行显示...
              display: -webkit-box;
              -webkit-line-clamp: 4; /* 限制行数为3 */
              -webkit-box-orient: vertical;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .temple_item:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1.25rem;
    }
    .section {
      .waterfallBox {
        .noMessage {
          font-weight: bold;
          font-size: 0.3rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
